<template>
	<div class="contatiner">
		<div class="cont">
			<div v-if="qq">
				<div class="h1" v-if="wxUrl">
					{{title}} 微信群
				</div>
				<div class="h1" v-else>
					{{title}} QQ群
				</div>
				<div class="contQRcode">
					<img :src="url_img" alt="">
				</div>
				<div class="qqhao" v-if="!wxUrl">QQ群号：{{qq}}</div>
				<div v-if="wxUrl" class="btn">
					长按二维码加群
				</div>
				<div v-else>
					<div v-if="this.lei" class="btn btn2" @click="copyqun($event, qq)">复制群QQ号</div>
					<div v-if="!this.lei" class="btn" @click="goqq()">点我跳转加群</div>
				</div>
				
			</div>

			<div v-if="!qq">
				<div class="address">
					<div class="h2" v-if="wxUrl">
						{{title}} 微信群
					</div>
					<div class="h2" v-else>
						{{title}}QQ群
					</div>
					
					<div class="contQRcode" v-if="wxUrl">
						<img :src="url_img" alt="">
					</div>
					<div class="qqhao qqhao2" v-else>QQ群号：{{qq}}</div>
				</div>
				
				<div class="btn btn2" v-if="wxUrl" >长按二维码加群</div>
				<div class="btn btn2" @click="copyqun($event, qq)" v-else>复制群QQ号</div>
			</div>
			<div class="groupList" v-if="!wxUrl">
				<div class="groupLi" v-for=" i in groupList">
					<div class="gorupName">{{i.title}}</div>
					<div class="gorupNumber">QQ群号：{{i.qq}}</div>
					<div class="gorupCopy" @click="copyqun($event, i.qq)">复制</div>
				</div>
			</div>
		</div>



		<div class="textdi" @click="copy($event, kf)">进群问题 可联系客服</div>
	</div>
</template>

<script>
	import {
		Notify,
	} from 'vant'
	import {
		Toast,
	} from 'vant';
	import {
		setOpenid,
		getOpenid
	} from '../../util/auth'
	import {
		createHash
	} from '../../util/hash'
	import https from '../../https'
	import QRCode from "qrcode"
	// var QRCode = require('qrcode')
	export default {
		components: {
			[Notify.name]: Notify,
		},
		data() {
			return {
				kf: "",
				url_img: "",
				url_img_wx: "",
				groupList: [],
				wxUrl: "",
			}
		},
		created() {
			var storage = window.sessionStorage;
			var kf = storage.getItem('kf')



			if (kf) {
				this.kf = kf
			}
			var that = this;
			this.lei = this.$route.query.lei;
			this.qqUrl = this.$route.query.qqUrl;
			this.wxUrl = this.$route.query.wxUrl;
			this.qq = this.$route.query.qq;
			this.title = this.$route.query.title;
			this.code = this.$route.query.code;
			this.type = this.$route.query.type;
			if (this.qqUrl) {
				QRCode.toDataURL(this.qqUrl, {
					errorCorrectionLevel: 'H'
				}, function(err, url) {
					console.log(url)
					that.url_img = url
				})
			}
			if (this.wxUrl) {
				that.url_img = this.wxUrl
				// QRCode.toDataURL(this.wxUrl, {
				// 	errorCorrectionLevel: 'H'
				// }, function(err, url) {
				// 	console.log(url)
				// 	that.url_img = url
				// })
			}
			if (this.code) {
				this.getCode(this.code)
				this.findActivityByCode(this.code)
			}
		},
		methods: {
			goqq() {
				window.location.href = this.qqUrl;
			},
			getCode(code) {
				var openid = getOpenid()
				if (!openid) {
					openid = createHash(16);
					setOpenid(openid);
				}
				var that = this
				https.fetchGet('/api/wx/lc/getLiveCode/' + getOpenid(), {
					code: code,
					type: that.type,
				}).then(res => {
					if (res.data && res.data.data) {
						that.url_img_wx = res.data.data
					}


				}).catch(err => {
					that.loading = false
					Notify({
						type: 'warning',
						message: '当前人数过多，请稍后重试'
					});
					console.log(err)
				})

			},
			findActivityByCode(code) {
				var that = this
				https.fetchGet('/api/wx/lc/findActivityByCode/', {
					code: code,
				}).then(res => {
					if (res.data && res.data.data) {
						console.log(res.data.data.items)
						// that.url_img_wx = res.data.data
						that.groupList = res.data.data.items
					}
				}).catch(err => {
					that.loading = false
					Notify({
						type: 'warning',
						message: '当前人数过多，请稍后重试'
					});
					console.log(err)
				})
			},
			// https://h5.ikaoyaner.com/api/wx/lc/findActivityByCode?code=zyk-qq-01

			copyqun(e, value) {
				try {
					value = value || '2690414527'
					const input = document.createElement('textarea')
					input.value = value
					document.body.appendChild(input)
					input.select()
					document.execCommand('Copy')
					document.body.removeChild(input)
					Toast.success('QQ群号复制成功');
				} catch (e) {
					Toast.fail('复制失败');
				}
			},
			copy(e, value) {
				try {
					value = value || '2690414527'
					const input = document.createElement('textarea')
					input.value = value
					document.body.appendChild(input)
					input.select()
					document.execCommand('Copy')
					document.body.removeChild(input)
					Toast.success('客服QQ号复制成功');
				} catch (e) {
					Toast.fail('复制失败');
				}
			}
		}
	}
</script>
<style>
	html {
		background-color: #fff;
	}
</style>
<style scoped="scoped">
	.gorupCopy {
		color: #04C183;
		font-size: 28px;
		padding: 18px;
	}

	.gorupNumber {
		color: #666;
		font-size: 28px;
	}

	.gorupName {
		background: #E9E9E9;
		border-radius: 8px;
		height: 50px;
		line-height: 50px;
		padding: 0 20px;
		color: #535353;
		font-size: 28px;
		font-weight: bold;
	}

	.groupList {
		padding: 0 35px;
		margin-top: 22px;
		overflow: hidden;
	}

	.groupLi {
		height: 78px;
		background: #F8F8F8;
		border-radius: 20px;
		margin-top: 20px;
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 0 18px;
	}

	.tishi {
		font-size: 30px;
		color: #333;
		text-align: center;
		margin-top: 20px;
	}

	.contQRcode_wx {
		width: 264px !important;
		height: 264px !important;
		padding: 20px;
		box-sizing: border-box;
		margin-top: 20px !important;
		margin-bottom: 0px !important;
	}

	.contQRcode_wx img {
		border-radius: 0 !important;
	}

	.cont {
		min-height: 1120px;

	}

	.contatiner {
		background-color: #fff;
	}

	.qqhao2 {
		margin-bottom: 55px;
	}

	.h2 {
		/* width: 318px; */
		display: inline-block;
		padding: 0 30px;
		height: 72px;
		background: #FFFFFF;
		border-radius: 36px;
		margin: 47px auto 60px;
		text-align: center;
		line-height: 72px;
		font-size: 30px;
		color: #000;
		font-weight: bold;
	}

	.address {
		width: 508px;
		text-align: center;
		background: #FFE65F;
		border-radius: 20px;
		margin: 60px auto 0;
		overflow: hidden;
	}

	html {
		background-color: #fff;
	}

	.contatiner {
		text-align: center;
		border-top: 1px solid #EAEAEA;

	}

	.h1 {
		/* width: 318px; */
		display: inline-block;
		padding: 0 54px;
		height: 74px;
		background: #FFE65F;
		border-radius: 20px;
		margin: 60px auto 0;
		font-size: 30px;
		color: #333333;
		font-weight: bold;
		text-align: center;
		line-height: 74px;
	}

	.contQRcode {
		width: 422px;
		/* height: 422px; */
		background: #FFFFFF;
		border-radius: 30px;
		border: 3px solid #00C080;
		margin: 30px auto;
	}

	.contQRcode img {
		width: 100%;
		height: 100%;
		border-radius: 30px;
	}

	.qqhao {
		font-size: 34px;
		text-align: center;
		color: #333;
		font-weight: bold;
	}

	.btn {
		width: 508px;
		height: 88px;
		background: linear-gradient(84deg, #2AC59A 0%, #00C080 100%);
		box-shadow: 0px 10px 20px 0px rgba(0, 192, 128, 0.33);
		border-radius: 44px;
		font-size: 36px;
		line-height: 88px;
		text-align: center;
		color: #fff;
		margin: 20px auto 0;
	}

	.textdi {
		font-size: 24px;
		font-weight: 400;
		color: #C1C1C1;
		line-height: 18px;
		text-align: center;
		padding: 50px;
	}

	rrr {}
</style>
